import React from "react";
import { Link, Redirect } from "react-router-dom";
import alertify from "alertifyjs";
import axios from "axios";
import UserActions from "../../Store/Actions/UserActions";
import APIModel from "../../Models/APIModel";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import Box from "@material-ui/core/Box";
import {
  displayAlertifyError,
  displayAlertifySuccess,
} from "../../util/functions";

class ForgotPassword extends React.Component {
  constructor() {
    super();
    this.state = {
      email: "",
      UserType: "",
      host: APIModel.HOST,
    };
    this.Forgot = this.Forgot.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    alertify.set("notifier", "position", "top-right");
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  Forgot = (e) => {
    e.preventDefault();
    let params = { email: this.state.email };

    if (this.state.email == "" || this.state.email === undefined) {
      displayAlertifyError({ error: "Please enter your email" });
      return false;
    }
    return axios
      .post(this.state.host + "forgot", params, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
      .then((response) => {
        console.log(response.data.message);
        if (response.data.message) {
          displayAlertifySuccess({ message: response.data.message });
          console.log(this.state.email);
          localStorage.setItem("user_email", this.state.email);
          setTimeout(() => {
            this.props.history.push("/verify");
          }, 1000);
        } else {
          displayAlertifyError({ error: response.data.error });
        }
      })
      .catch(this.globalErrorHandler)
      .finally();
  };

  globalErrorHandler = (error) => {
    const { response } = error;
    let message;
    if (response) {
      message = response.data.message;
    } else {
      message = error.toString();
    }
  };

  render() {
    return (
      <main className="">
        <div className="container-fluid container-login">
          <div
            className="row justify-content-center align-items-center"
            style={{ height: "100vh" }}
          >
            <div className="col-12 col-md-7 col-xl-5">
              <div className="card card-signin my-5">
                <div div className="card-header card-header-primary">
                  <h4 className="card-title text-center text-uppercase font-weight-bold">
                    <b>Reset Password</b>
                  </h4>
                </div>
                <div className="card-body">
                  <div className="logo text-center mb-3">
                    <img
                      src={process.env.PUBLIC_URL + "/logo.png"}
                      alt="Logo"
                      className="logo"
                    />
                  </div>
                  <form onSubmit={this.Forgot}>
                    <input
                      type="hidden"
                      name="_token"
                      defaultValue="hLuKijK86fLz0Xp4rJoK4Rzxu9jXz25VZF9dJ4mP"
                    />

                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <input
                            id="email"
                            type="email"
                            className="form-control"
                            name="email"
                            placeholder="Enter Your Email"
                            onChange={this.onChange}
                            value={this.state.email}
                            autoFocus
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="mt-2">
                      <button type="submit" className="btn btn-primary w-100">
                        Send Password Reset Email
                      </button>
                    </div>
                    <div class="mt-3">
                      <Link to="/" className="link-colour">
                        <Box fontWeight="fontWeightBold">
                          &#8592; Back To Log In
                        </Box>
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }
}

export default ForgotPassword;
